<template>
    <div class="detail-page">
        <div class="detail-container">
            <!-- 左侧主内容区 -->
            <div class="main-content">
                <!-- 面包屑导航 -->
                <div class="breadcrumb">
                    当前位置：<span class="link" @click="goBack">交易信息</span> &gt; {{getPageTitle(noticeType)}}
                </div>

                <!-- 公告标题 -->
                <h1 class="notice-title">{{ detail.noticeName }}</h1>

                <!-- 基本信息 -->
                <div class="info-section">
                    <div class="info-row">
                        <span class="label" v-if="noticeType!='5'">项目编号：</span>
                        <span class="value">{{ detail.projectCode }}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">项目地点：</span>
                        <span class="value">{{ detail.provinceName }}-{{ detail.cityName }}-{{ detail.countyName }}</span>
                    </div>
                </div>

                <!-- 公告内容 -->
                <div class="notice-content" v-html="detail.content"></div>
            </div>

            <!-- 右侧信息栏 -->
            <div class="side-panel" v-if="noticeType==1">
                <!-- 文件获取时间 -->
                <div class="info-card">
                    <div class="card-title">文件获取时间</div>
                    <div class="card-row">
                        <span class="card-label">开始：</span>
                        <span class="card-value">{{ formatTime(detail.documentAcquisitionStartTime) }}</span>
                    </div>
                    <div class="card-row">
                        <span class="card-label">截止：</span>
                        <span class="card-value">{{ formatTime(detail.documentAcquisitionEndTime) }}</span>
                    </div>
                </div>

                <!-- 投标文件递交截止时间 -->
                <div class="info-card">
                    <div class="card-title">投标文件递交截止时间</div>
                    <div class="card-row">
                        <span class="card-label">截止：</span>
                        <span class="card-value">{{ formatTime(detail.documentSubmissionDeadline) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getNoticeDetail } from '@/api/modules/home'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default {
    data() {
        return {
            noticeCode: this.$route.query.noticeCode,
            noticeType: this.$route.query.noticeType,
            detail: {}
        }
    },
    mounted() {
        this.getNoticeDetail()
    },
    methods: {
        getPageTitle(){
            if (this.noticeType === '1') {
                return '招标公告'
            } else if (this.noticeType === '2') {
                return '中标公告'
            } else if (this.noticeType === '3') {
                return '中标候选人公示'
            } else if (this.noticeType === '5') {
                return '计划公告'
            }
            return
        },


        goBack() {
            this.$router.push('/deal')
        },
        formatTime(time) {
            if (!time) return '-'
            return time.replace(' ', ' ')
        },
        getNoticeDetail() {
            getNoticeDetail({
                noticeCode: this.noticeCode,
                noticeType: this.noticeType
            }).then(res => {
                if (res.code === 200) {
                    this.detail = res.data || {}
                    // 清理富文本内容中的 Word 样式
                    if (this.detail.content) {
                        this.detail.content = sanitizeHtml(this.detail.content)
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.detail-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 20px 0;
}

.detail-container {
    margin: 0 auto;
    display: flex;
    gap: 20px;
    padding: 0 10%;
}

.main-content {
    flex: 1;
    background: #fff;
    padding: 24px;
    border-radius: 4px;
}

.breadcrumb {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    
    .link {
        color: #005EEC;
        cursor: pointer;
        
        &:hover {
            text-decoration: underline;
        }
    }
}

.notice-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
}

.info-section {
    margin-bottom: 24px;
    padding: 16px;
    background: #fafafa;
    border-radius: 4px;
    
    .info-row {
        display: flex;
        margin-bottom: 12px;
        font-size: 14px;
        
        &:last-child {
            margin-bottom: 0;
        }
        
        .label {
            color: #666;
            min-width: 80px;
        }
        
        .value {
            color: #333;
            flex: 1;
        }
    }
}

.notice-content {
    font-size: 14px;
    line-height: 1.8;
    color: #333;

    :deep(h2), :deep(h3), :deep(h4) {
        margin: 20px 0 12px;
        color: #333;
    }

    :deep(h3) {
        font-size: 18px;
    }

    :deep(h4) {
        font-size: 16px;
    }

    :deep(p) {
        margin: 12px 0;
    }

    :deep(ul), :deep(ol) {
        padding-left: 24px;
        margin: 12px 0;
    }

    :deep(li) {
        margin: 8px 0;
    }

    :deep(hr) {
        border: none;
        border-top: 1px solid #eee;
        margin: 20px 0;
    }

    // 表格样式
    :deep(table) {
        border-collapse: collapse;
        border: 1px solid #ddd;
        margin: 16px 0;
        font-size: 14px;
        width: auto !important;

        td, th {
            border: 1px solid #ddd;
            padding: 6px 10px;
            vertical-align: middle;
        }

        th {
            background: #f5f5f5;
            font-weight: 600;
            text-align: center;
        }
    }
}

.side-panel {
    width: 280px;
    flex-shrink: 0;
}

.info-card {
    background: #fff;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
    
    .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid #eee;
    }
    
    .card-row {
        display: flex;
        font-size: 13px;
        margin-bottom: 8px;
        
        &:last-child {
            margin-bottom: 0;
        }
        
        .card-label {
            color: #666;
            min-width: 45px;
        }
        
        .card-value {
            color: #333;
        }
    }
}
</style>
<style>
@media print {
    /* 让 flex 布局在打印时纵向堆叠，不裁切子元素 */
    .detail-container {
        display: block !important;
    }
    /* 主内容区和富文本内容完整展开，不裁切 */
    .detail-container .main-content,
    .notice-content,
    .notice-content * {
        overflow: visible !important;
        height: auto !important;
        max-height: none !important;
    }
    /* 打印时隐藏右侧信息栏 */
    .side-panel {
        display: none !important;
    }
}
</style>